import React, { useState, useEffect } from "react";

const DiscountCalculator = ({ setTasaDescuento }) => {
  const [facturacionMensual, setFacturacionMensual] = useState(0);
  const [giroComercial, setGiroComercial] = useState("");
  const [mezclaCredito, setMezclaCredito] = useState(2);
  const [mezclaDebito, setMezclaDebito] = useState(1);
  const [mezclaInternacional, setMezclaInternacional] = useState(2.5);
  const [valorNumerico, setValorNumerico] = useState(0);

  const girosData = {
    "Agencias de Viajes": { mezclaCredito: 44.9, mezclaDebito: 12.2, mezclaInternacional: 42.9 },
    "Agregadores": { mezclaCredito: 19.4, mezclaDebito: 64.9, mezclaInternacional: 15.7},
    "Aseguradoras": { mezclaCredito: 75.3, mezclaDebito: 22.3, mezclaInternacional: 2.3 },
    "Beneficencia": { mezclaCredito: 43.3, mezclaDebito: 53.3, mezclaInternacional: 3.4 },
    "Colegios y Universidades": { mezclaCredito: 41.8, mezclaDebito: 54.8, mezclaInternacional: 3.4 },
    "Comida Rápida": { mezclaCredito: 33.3, mezclaDebito: 60.0, mezclaInternacional: 6.6 },
    "Educación Básica": { mezclaCredito: 50.6, mezclaDebito: 47.2, mezclaInternacional: 2.2 },
    "Entretenimiento": { mezclaCredito: 48.2, mezclaDebito: 45.8, mezclaInternacional: 6.0 },
    "Estacionamientos": { mezclaCredito: 52.8, mezclaDebito: 44.2, mezclaInternacional: 3.0 },
    "Farmacias": { mezclaCredito: 35.0, mezclaDebito: 49.3, mezclaInternacional: 15.7 },
    "Gasolineras": { mezclaCredito: 34.1, mezclaDebito: 63.9, mezclaInternacional: 2.0 },
    "Gobierno": { mezclaCredito: 43.376, mezclaDebito: 53.819, mezclaInternacional: 2.805 },
    "Guarderías": { mezclaCredito: 60.187, mezclaDebito: 29.043, mezclaInternacional: 10.770 },
    "Hospitales": { mezclaCredito: 35.488, mezclaDebito: 44.874, mezclaInternacional: 19.638 },
    "Hoteles": { mezclaCredito: 14.789, mezclaDebito: 9.623, mezclaInternacional: 75.587 },
    "Médicos y Dentistas": { mezclaCredito: 42.028, mezclaDebito: 44.973, mezclaInternacional: 12.998 },
    "Miscelánea": { mezclaCredito: 29.558, mezclaDebito: 66.162, mezclaInternacional: 4.281 },
    "Otros": { mezclaCredito: 39.810, mezclaDebito: 54.855, mezclaInternacional: 5.336 },
    "Peaje": { mezclaCredito: 69.570, mezclaDebito: 28.787, mezclaInternacional: 1.642 },
    "Refacciones y Ferreterías": { mezclaCredito: 36.330, mezclaDebito: 60.811, mezclaInternacional: 2.859 },
    "Renta de Autos": { mezclaCredito: 34.978, mezclaDebito: 12.937, mezclaInternacional: 52.085 },
    "Restaurantes": { mezclaCredito: 35.268, mezclaDebito: 45.975, mezclaInternacional: 18.757 },
    "Salones de Belleza": { mezclaCredito: 42.943, mezclaDebito: 47.818, mezclaInternacional: 9.240 },
    "Supermercados": { mezclaCredito: 27.869, mezclaDebito: 66.364, mezclaInternacional: 5.767 },
    "Telecomunicaciones": { mezclaCredito: 40.149, mezclaDebito: 58.652, mezclaInternacional: 1.199 },
    "Transporte Aéreo": { mezclaCredito: 61.024, mezclaDebito: 25.018, mezclaInternacional: 13.957 },
    "Transporte Terrestre de Pasajeros": { mezclaCredito: 32.753, mezclaDebito: 63.943, mezclaInternacional: 3.304 },
    "Ventas al Detalle (Retail)": { mezclaCredito: 39.585, mezclaDebito: 53.894, mezclaInternacional: 6.521 },
  };
  const calcularTasaDescuento = () => {
    if (!giroComercial || !girosData[giroComercial]) {
      return 0;// Si no hay un giro seleccionado, la tasa es 0.
    }

    // Obtener los valores de mezcla desde girosData
    const mezclaGiro = girosData[giroComercial];
    const mezclaCreditoGiro = mezclaGiro.mezclaCredito;
    const mezclaDebitoGiro = mezclaGiro.mezclaDebito;
    const mezclaInternacionalGiro = mezclaGiro.mezclaInternacional;

    const creditoCalculo = (valorNumerico * mezclaCreditoGiro) / 100;
    const debitoCalculo = (valorNumerico * mezclaDebitoGiro) / 100;
    const internacionalCalculo = (valorNumerico * mezclaInternacionalGiro) / 100;

    // Aplicar la tasa de descuento ingresada por el usuario
    const tasaCredito = (creditoCalculo * mezclaCredito) / 100;
    const tasaDebito = (debitoCalculo * mezclaDebito) / 100;
    const tasaInternacional = (internacionalCalculo * mezclaInternacional) / 100;

    // Sumar todas las tasas calculadas
    return tasaCredito + tasaDebito + tasaInternacional;
  };

  useEffect(() => {
    const tasa = calcularTasaDescuento();
    setTasaDescuento(tasa);
  }, [facturacionMensual, mezclaCredito, mezclaDebito, mezclaInternacional, giroComercial]);

  return (
    <>
      <div className="bg-[#F0F0F0] p-6 rounded-lg mx-auto min-h-[550px] flex flex-col justify-center">
        <div className="grid grid-cols-3 items-center text-center h-full gap-6 xs:grid-cols-1">
          <div className="p-6 text-[#EC0000] font-bold text-4xl leading-normal border-r border-[#EC0000] flex items-center justify-center h-full xs:border-r-0">
            Calcula tu pago por <br /> Tasa de Descuento
          </div>

          <div className="p-6 border-r border-[#EC0000] flex flex-col items-start xs:border-r-0">
            <h3 className="text-[#EC0000] font-bold text-4xl border-b border-[#EC0000] pb-2 w-full text-center">
              Concepto
            </h3>
            <p className="text-[#EC0000] mt-6 text-xl">Facturación Mensual</p>
            <p className="text-[#EC0000] mt-6 text-xl">Giro Comercial</p>
            <p className="text-[#EC0000] mt-6 text-xl">Tasa de Descuento de Crédito</p>
            <p className="text-[#EC0000] mt-6 text-xl">Tasa de Descuento de Débito</p>
            <p className="text-[#EC0000] mt-6 text-xl">Tasa de Descuento Internacional</p>
          </div>

          <div className="p-6 flex flex-col items-start">
            <h3 className="text-[#EC0000] font-bold text-4xl border-b border-[#EC0000] w-full text-center">
              Monto
            </h3>
            <input
              type="text"
              className="mt-6 w-full text-left border rounded-md p-2"
              value={facturacionMensual}
              onChange={(e) => {
                const valorSinFormato = e.target.value.replace(/\D/g, ""); // solo números
                const numero = parseInt(valorSinFormato, 10) || 0;
                setValorNumerico(numero);
                setFacturacionMensual(
                  `$${numero.toLocaleString("es-MX", { minimumFractionDigits: 0 })}`
                );
              }}
              placeholder="Ingresa el monto"
            />


            <select
              className="mt-6 w-full text-left border rounded-md p-2"
              value={giroComercial}
              onChange={(e) => setGiroComercial(e.target.value)}
            >
              <option value="">Selecciona un Giro</option>
              {Object.keys(girosData).map((giro) => (
                <option key={giro} value={giro}>
                  {giro}
                </option>
              ))}
            </select>
            <input
              type="text"
              className="mt-6 w-full text-left border rounded-md p-2"
              value={mezclaCredito + "%"}
              onChange={(e) => {
                const value = e.target.value;
                if (value === "" || (/^\d*\.?\d*$/.test(value) && parseFloat(value) >= 0 && parseFloat(value) <= 5)) {
                  setMezclaCredito(value);
                }
              }}
              min="0"
              max="5"
              step="0.1"
            />

            <input
              type="text"
              className="mt-6 w-full text-left border rounded-md p-2"
              value={mezclaDebito + "%"}
              onChange={(e) => {
                const value = e.target.value;
                if (value === "" || (/^\d*\.?\d*$/.test(value) && parseFloat(value) >= 0 && parseFloat(value) <= 5)) {
                  setMezclaDebito(value);
                }
              }}
              min="0"
              max="5"
              step="0.1"
            />

            <input
              type="text"
              className="mt-6 w-full text-left border rounded-md p-2"
              value={mezclaInternacional + "%"}
              onChange={(e) => {
                const value = e.target.value;
                if (value === "" || (/^\d*\.?\d*$/.test(value) && parseFloat(value) >= 0 && parseFloat(value) <= 5)) {
                  setMezclaInternacional(value);
                }
              }}
              min="0"
              max="5"
            />


          </div>
        </div>
      </div>

      <div className="flex text-[#EC0000] mt-10 text-xl pt-10">
        <h3 className="text-left ml-64 text-4xl pr-4 xs:ml-0 xs:text-3xl xs:pr-0 xs:text-center">
          Tu Tasa de Descuento equivale a:
        </h3>
        <input
          className="text-center h-12 bg-[#F0F0F0] border-none rounded-md shadow-sm px-4 w-40 xs:mr-8"
          value={"$" + calcularTasaDescuento().toFixed(0)}
          readOnly
        />
      </div>
    </>
  );
};

export default DiscountCalculator;
